import React, { Component } from 'react';
import HWLog from '../../HWLibrary/HWLog';

class MessageA19 extends Component {

  render() {
    let tableHeaderColumns = this.parseTableHeaderColumns();
    let tableRows = this.parseTableRowsData();
    return (
      <div className="s360-message-cotainer-custom-a19-received">
        <div className="s360-message-box-custom-a19-received" style={this.messageBoxStyle()}>
        <table className="table table-striped table-bordered table-sm">
          <thead>
            <tr>
            {tableHeaderColumns.map((columnName, i) => <th key={i} style={{textAlign:"center", whiteSpace:"nowrap", padding:"5px"}}>{columnName}</th>)}
            </tr>
          </thead>
          <tbody>
            {tableRows.map((row, i) =>
              <tr key={i}>
                {row.map((rowValue, j) => <td key={j} style={{textAlign:"center"}}>{rowValue}</td>)}
              </tr>
            )}
          </tbody>
        </table>
        </div>
      </div>

    );
  }

  parseTableHeaderColumns = () => {
    try {
      return JSON.parse(this.props.entry.text).headers || []
    } catch (error) {
      HWLog.warn("Invalid Table Data for Custom Type A19:");
    }
    return []
  }

  parseTableRowsData = () => {
    try {
      return JSON.parse(this.props.entry.text).data || []
    } catch (error) {
      HWLog.warn("Invalid Table Data for Custom Type A19:");
    }
    return []
  }

  messageBoxStyle = () => {
    let config = this.props.config;
    return { background: config.designDetails.senderMessageColor, fontFamily: config.designDetails.SenderMessageFont, fontSize: config.designDetails.SenderMessageFontSize, color: config.designDetails.senderMessageFontColor }
    // switch (this.props.message.type) {
    //     case MessageType.received: return { background: config.designDetails.senderMessageColor, fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageFontSize, color: config.designDetails.senderMessageFontColor }
    //     case MessageType.sent: return { background: config.designDetails.recieverMessageColor, fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageFontSize, color: config.designDetails.recieverMessageFontColor }
    //     case MessageType.info: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
    //     default: return {}
    // }
}

}

export default MessageA19;